export default (theme) => ({
  content: {
    padding: '20px 30px',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '20px',
    },
  },
  pageTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  pageSubtitle: {
    marginBottom: theme.spacing(1),
  },
  gridContainer: {
    width: '100%',
  },
  gridWrapper: {
    width: '100%',
    minWidth: 0,
    /**
     * DataGrid uses height:100% on .tabl-container, table, and tbody. Inside FolderNav tabs
     * there is no fixed-height ancestor, so the body collapses with overflow:hidden and rows
     * are not visible. Let the table grow with content instead.
     */
    '& .tabl-container': {
      height: 'auto !important',
      minHeight: 360,
    },
    '& .main-table': {
      height: 'auto !important',
    },
    '& .main-table tbody': {
      height: 'auto !important',
      maxHeight: 'none !important',
      overflow: 'visible !important',
    },
    '& > div': {
      backgroundColor: theme.palette.common.white,
    },
  },
  emptyState: {
    marginBottom: theme.spacing(1),
  },
  errorText: {
    marginBottom: theme.spacing(1),
  },
  rowActions: {
    display: 'inline-flex',
    alignItems: 'stretch',
    gap: theme.spacing(1),
    flexWrap: 'nowrap',
  },
  switchButton: {
    fontWeight: 600,
    textTransform: 'none',
    borderWidth: 2,
    minWidth: 168,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    justifyContent: 'center',
    '&:hover': {
      borderWidth: 2,
    },
  },
  historyButton: {
    textTransform: 'none',
    fontWeight: 500,
    minWidth: 108,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    justifyContent: 'center',
    borderColor: theme.palette.divider,
    color: theme.palette.text.primary,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.text.secondary,
    },
  },
  historyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  historyEntry: {
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  },
  historyTimestamp: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  historyChip: {
    marginRight: theme.spacing(0.5),
    fontWeight: 600,
  },
  lmsBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    height: 28,
    paddingLeft: theme.spacing(1.25),
    paddingRight: theme.spacing(1.25),
    borderRadius: 999,
    fontSize: '0.8125rem',
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    width: 'fit-content',
    maxWidth: '100%',
    '& svg': {
      fontSize: 16,
      flexShrink: 0,
    },
  },
  lmsBadgeCanvas: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  lmsBadgeD2l: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
  },
  lmsBadgeD2lDefault: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    border: `1px dashed ${theme.palette.divider}`,
  },
  lmsBadgeDefaultTag: {
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(0.75),
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    borderRadius: theme.shape.borderRadius,
    fontSize: '0.6875rem',
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.grey?.[100] || '#F3F4F6',
  },
  lmsBadgeTooltipWrap: {
    display: 'inline-flex',
  },
});
